import moment from "moment-timezone";
import useSWR from "swr";

// The employee's time off plans for the time sheet validations (balance, maximum hours allowed to
// be taken, probation, ...), as the team time sheet loads them. `self`: the employee's own time
// sheet, read from the profile, since an employee may not be allowed to read other users' plans
// (active plans only, so a plan before a transfer is not counted; the save still checks it).
export const useTimeOffPlans = ({ userId, from, to, self = false }) => {
	return useSWR(() => {
		if (self) {
			return { url: "/profile/time-off/plan", params: { status: "active" } };
		}
		if (!userId || !from || !to) {
			return null;
		}
		return {
			url: `/users/${userId}/time-off`,
			params: {
				range: {
					startDate: moment(from).format("YYYY-MM-DD"),
					endDate: moment(to).format("YYYY-MM-DD"),
				},
				bringAllPlans: true,
			},
		};
	});
};
